import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ScheduleService } from 'services/ScheduleService';
import { ShiftProfileGroup } from 'repository/schedule/@types/ShiftProfileGroup';
import { FormShiftProfileGroup } from './FormShiftProfileGroup';
import { ShiftProfileGroupFormValues } from 'schemas/ShiftProfileGroup';

interface UpdateProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: any;
    rowToEdit: ShiftProfileGroup;
    reloading: () => void;
}

const scheduleService = new ScheduleService();

export const UpdateShiftProfileGroup: FC<UpdateProps> = ({ open, setOpen, rows, rowToEdit, reloading }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values: ShiftProfileGroupFormValues) => {
        const payload: ShiftProfileGroup = {
            ...rowToEdit,
            shift_profile_group_name: values.name,
            shift_profile_group_description: values.description || undefined,
            shift_profiles: values.items.map((it) => ({
                shift_profile_id: it.shift_profile_id as number,
                monday: it.monday,
                tuesday: it.tuesday,
                wednesday: it.wednesday,
                thursday: it.thursday,
                friday: it.friday,
                saturday: it.saturday,
                sunday: it.sunday,
            })),
        };

        try {
            await scheduleService.shift_profile_group.update(payload.shift_profile_group_id, payload);
            enqueueSnackbar('Grupo de perfil de turno actualizado', { variant: 'success' });
            reloading();
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('general.errors.unexpected'), { variant: 'error' });
            throw error;
        }
    };

    return (
        <FormShiftProfileGroup
            open={open}
            setOpen={setOpen}
            rows={rows}
            initialValues={{
                id: rowToEdit?.id,
                name: rowToEdit?.shift_profile_group_name,
                description: rowToEdit?.shift_profile_group_description ?? '',
                items: rowToEdit?.shift_profiles ?? [],
            }}
            titleKey={'Editar grupo de perfil de turno'}
            submitLabel={'Guardar cambios'}
            onSubmit={handleSubmit}
        />
    );
};
